import { render, staticRenderFns } from "./EditMovement.vue?vue&type=template&id=f4b492bc"
import script from "./EditMovement.vue?vue&type=script&lang=js"
export * from "./EditMovement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports